import { repository, adminURL } from "@/api/base"

export default {
  async getCatalog() {
    const { data } = await repository.get(adminURL + '/admin/role/findAll')
    return data
  },

  async create(body) {
    const { data } = await repository.post(adminURL + '/admin/role', body)
    return data
  },

  async update(body) {
    const { data } = await repository.put(adminURL + '/admin/role', body)
    return data
  },

  async remove(id) {
    return await repository.delete(adminURL + '/admin/role/' + id)
  }
}
